import { getPushRecords, retryPushRecords } from '@/api/local-material'

export default {
    props: {
        showPushRecords: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            tableGrid: {},
            retryLoading: false,
            selectedRowKeys: [],
            filters: {
                material_name: '',
                status: undefined,
                media: undefined,
            },
            statusMap: {
                1: { text: '待推送', color: 'blue' },
                2: { text: '成功', color: 'green' },
                3: { text: '失败', color: 'red' },
            },
        }
    },
    mounted() {
        this.tableGrid = {
            id: 'push_records',
            height: 500,
            loading: false,
            border: true,
            resizable: true,
            showOverflow: true,
            showHeaderOverflow: true,
            size: 'small',
            align: 'center',
            stripe: true,
            columns: [
                { type: 'checkbox', width: 60, fixed: 'left' },
                { minWidth: 200, title: '素材名称', field: 'material_name', fixed: 'left' },
                { minWidth: 100, title: '封面', field: 'material_cover', slots: { default: 'material_cover' } },
                { minWidth: 90, title: '本地状态', field: 'material_deleted_at', slots: { default: 'material_deleted_at' } },
                { minWidth: 200, title: '目标广告主', field: 'target_advertiser_name', slots: { default: 'target_advertiser_name' } },
                { minWidth: 200, title: '来源广告主', field: 'source_advertiser_name', slots: { default: 'source_advertiser_name' } },
                { minWidth: 90, title: '推送状态', field: 'status', slots: { default: 'status' } },
                { minWidth: 200, title: '错误信息', field: 'error_msg', slots: { default: 'error_msg' } },
                { minWidth: 170, title: '推送时间', field: 'created_at' },
                { minWidth: 80, title: '操作', slots: { default: 'action' }, fixed: 'right' },
            ],
            data: [],
            pagerConfig: {
                currentPage: 1,
                total: 0,
                pageSize: 20,
                pageSizes: [10, 20, 30, 50],
                layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total'],
            },
            toolbarConfig: {
                perfect: true,
                slots: { buttons: 'toolbar_buttons' },
            },
            customConfig: {
                storage: { visible: true, resizable: true, sort: true, fixed: true },
            },
        }
        this.getData()
    },
    methods: {
        getData() {
            this.tableGrid.loading = true
            const params = {
                ...this.filters,
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize,
            }
            if (!params.material_name) delete params.material_name
            getPushRecords(params).then(res => {
                this.tableGrid.data = res.data.list || []
                this.tableGrid.pagerConfig.total = res.data.total || 0
            }).finally(() => {
                this.tableGrid.loading = false
            })
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.getData()
        },
        handleRowChange(result) {
            this.selectedRowKeys = result.records.flatMap(item => item.id)
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        resetSearch() {
            this.filters = { material_name: '', status: undefined, media: undefined }
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        batchRetry() {
            if (this.selectedRowKeys.length === 0) {
                this.$message.warning('请先选择要重试的推送记录')
                return
            }
            this.retryLoading = true
            retryPushRecords({ ids: this.selectedRowKeys }).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(res.message || '重试完成')
                    this.selectedRowKeys = []
                    this.getData()
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.retryLoading = false
            })
        },
        singleRetry(record) {
            if (record.status !== 3) return
            this.retryLoading = true
            retryPushRecords({ ids: [record.id] }).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(res.message || '重试完成')
                    this.getData()
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.retryLoading = false
            })
        },
        close() {
            this.$emit('update:showPushRecords', false)
        },
    }
}
